// src/config/sellDoCampaigns.js
// Source of truth for Sell.Do Campaign → SRD attribution.
// Copied from Sell.Do's Campaign list. Whenever a new campaign is
// created and linked in Sell.Do, add one more block below in the
// exact same shape (get the SRD from Sell.Do's campaign screen).

const RAW_CAMPAIGNS = [
  // ── Facebook / Meta Ads ──────────────────────────────────────────
  {
    campaignName: "Sangamam_Leads_Campaign_02",
    sourceName: "facebook",
    subSourceName: "meta ads",
    projectName: "Sangamam",
    srd: "6a743f69a2e3a9154a379030",
  },
  {
    campaignName: "Sangamam_leads_campaign",
    sourceName: "facebook",
    subSourceName: "meta ads",
    projectName: "Sangamam",
    srd: "6a74410147c7f508665e47b6",
  },
  {
    campaignName: "Influencer_Campaign_05",
    sourceName: "facebook",
    subSourceName: "meta ads",
    projectName: "Sangamam",
    srd: "6a74423b735daf3eb8d4b17f",
  },
  {
    campaignName: "Kanchipuram_Leads_campaign",
    sourceName: "facebook",
    subSourceName: "meta ads",
    projectName: "GOWRI ANANDHAM NAGAR (PHASE 1)",
    srd: "6a743fb8a2e3a91883378e81",
  },
  {
    campaignName: "Gowri anadham_Leads_Campaign",
    sourceName: "facebook",
    subSourceName: "meta ads",
    projectName: "GOWRI ANANDHAM NAGAR (PHASE 1)",
    srd: "6a74429547c7f50daacf0625",
  },
  {
    campaignName: "Utsav_Leads_Campaign",
    sourceName: "facebook",
    subSourceName: "meta ads",
    projectName: "Sholavaram", // ← corrected from "Not Tagged"
    srd: "6a743feea2e3a9159037900e",
  },

  // ── Google / CPC ──────────────────────────────────────────────────
  {
    campaignName: "PMax | Green Cove | Site Launch | Chennai | Leads",
    sourceName: "Google",
    subSourceName: "CPC",
    projectName: "Green Cove",
    projectId: "694b8d6ee1148739a3c7132c",
    srd: "6a746712c32393cebc956bdb",
  },
  {
    campaignName: "Anandham_Thiruporur_plots",
    sourceName: "Google",
    subSourceName: "CPC",
    projectName: "Sangamam",
    projectId: "698088b15d8defdcfcd63394",
    srd: "6a746754a2e3a9522f95db84",
    landingPaths: ["/sangamam"],
  },
  {
    campaignName: "Pon_Ananatham_Search_Campaign_01",
    sourceName: "Google",
    subSourceName: "CPC",
    projectName: "Gowri_Anandham_(Phase 2)",
    projectId: "6a0802575d8defe45b2c47f6",
    srd: "6a746793e0cb08d28aa3b5f4",
    landingPaths: ["/gowri-anandham"],
  },
];

// Google Ads/URL builders can turn spaces into `+`, and campaign naming often
// differs only by spaces, underscores or punctuation. Compare the meaningful
// characters so those harmless URL-format differences do not lose attribution.
const normalize = (str = "") =>
  String(str)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const SELLDO_CAMPAIGNS = RAW_CAMPAIGNS.reduce((map, row) => {
  map[normalize(row.campaignName)] = row;
  return map;
}, {});

export const normalizeCampaignName = normalize;

export const findGoogleCampaignByLandingPath = (pathname = "") =>
  RAW_CAMPAIGNS.find(
    (row) =>
      row.sourceName.toLowerCase() === "google" &&
      row.landingPaths?.some(
        (path) => pathname === path || pathname.startsWith(`${path}/`),
      ),
  ) || null;
